/**
 * Sorteio da dupla medicao: no minimo 10% das fichas da visita (folha 1 da
 * ficha v1.0) ganham uma segunda medicao, por outro avaliador, as cegas. E dela
 * que sai o teste de repetibilidade (ICC).
 *
 * Sorteio, e nao escolha: quem escolhe tende a remedir o animal facil, e o ICC
 * sai otimista. `aleatorio` e injetavel so para o teste ser deterministico.
 */
export const FRACAO_DUPLA_MEDICAO = 0.1;

/** Quantas fichas vao para a dupla medicao: 10% arredondado para cima, minimo 1. */
export const tamanhoDaAmostra = (total: number, fracao = FRACAO_DUPLA_MEDICAO) =>
  total === 0 ? 0 : Math.max(1, Math.ceil(total * fracao));

export function sortearDuplaMedicao<T>(
  fichas: readonly T[],
  aleatorio: () => number = Math.random,
  fracao = FRACAO_DUPLA_MEDICAO,
): T[] {
  // Fisher-Yates parcial: embaralha so o comeco que interessa.
  const copia = [...fichas];
  const n = tamanhoDaAmostra(copia.length, fracao);
  for (let i = 0; i < n; i++) {
    const j = i + Math.floor(aleatorio() * (copia.length - i));
    [copia[i], copia[j]] = [copia[j]!, copia[i]!];
  }
  return copia.slice(0, n);
}
